import storage from "good-storage";
// token
const USER_TOKEN_KEY = "__usertoken__";
// db登录账号的用户名
const DB_USER_REAL_NAME = "__dbUserRealName__";
// 效期历史记录
const VALID_DATE_HISLIST = "__validDateHislist__"
// 是否设置了项目和仓库权限范围 true：已设置、false：未设置
const SET_FLAG = "__setFlag__"
// 用户拥有的权限
const USER_AUTH = "__userAuth__"
// 用户拥有的导航页面
const USER_MENU = "__userMenu__"
// 用户设置的首页
const USER_SET_HOME = "__userSetHome__"
// 用户设置的首页keyword
const USER_SET_HOME_KEYWORD = "__userSetHomeKeyword__"

/* url */
const URL = '__url__'
/* tags页面 */
const TAGS = '__tags__'

function getToken() {
  // console.log('取token--', storage.get(USER_TOKEN_KEY))
  return storage.get(USER_TOKEN_KEY);
}

function saveToken(val) {
  // console.log('存token--')
  storage.set(USER_TOKEN_KEY, val);
}

function deleteToken() {
  // console.log('删除token--')
  storage.remove(USER_TOKEN_KEY);
}
function saveDBUserRealName(val) {
  storage.set(DB_USER_REAL_NAME, val);
}
function getDBUserRealName() {
  return storage.get(DB_USER_REAL_NAME);
}

function delDBUserRealName() {
  return storage.remove(DB_USER_REAL_NAME);
}

// 保存收费登记--退货服务中效期输入历史记录
function saveValidDateHislist(val) {
  storage.set(VALID_DATE_HISLIST, JSON.stringify(val));
}
// 获取收费登记--退货服务中效期输入历史记录
function getValidDateHislist() {
  if (storage.get(VALID_DATE_HISLIST)) {
    return JSON.parse(storage.get(VALID_DATE_HISLIST))
  } else {
    return []
  }
}


/* 存url */
function saveUrl(val) {
  storage.set(URL, val)
}

/* 取url */
function getUrl() {
  return storage.get(URL)
}

/* 存是否设置了项目和仓库权限范围 */
function saveSetFlag(val) {
  storage.set(SET_FLAG, val)
}

/* 取是否设置了项目和仓库权限范围 */
function getSetFlag() {
  return storage.get(SET_FLAG)
}

/* tags页面 */
function saveTags(val) {
  storage.session.set(TAGS, JSON.stringify(val))
}
function getTags() {
  if (storage.session.get(TAGS) !== undefined) {
    return JSON.parse(storage.session.get(TAGS))
  } else {
    return []
  }
}
function delTags() {
  storage.session.remove(TAGS)
}

function saveUserAuth(val) {
  storage.session.set(USER_AUTH, JSON.stringify(val))
}
function getUserAuth() {
  if (storage.session.get(USER_AUTH) !== undefined) {
    return JSON.parse(storage.session.get(USER_AUTH))
  } else {
    return []
  }
}

function saveUserMenu(val) {
  storage.session.set(USER_MENU, JSON.stringify(val))
}
function getUserMenu() {
  if (storage.session.get(USER_MENU) !== undefined) {
    return JSON.parse(storage.session.get(USER_MENU))
  } else {
    return []
  }
}

/* 用户设置首页 */
function saveUserSetHome(val) {
  storage.set(USER_SET_HOME, val);
}
function getSaveUserSetHome() {
  return storage.get(USER_SET_HOME);
}
/* 用户设置首页keyword */
function saveUserSetHomeKeyWord(val) {
  storage.set(USER_SET_HOME_KEYWORD, val);
}
function getUserSetHomeKeyWord() {
  return storage.get(USER_SET_HOME_KEYWORD);
}

export {
  getToken,
  saveToken,
  deleteToken,
  saveDBUserRealName,
  getDBUserRealName,
  delDBUserRealName,
  saveValidDateHislist,
  getValidDateHislist,
  saveUrl,
  getUrl,
  saveTags,
  getTags,
  delTags,
  saveSetFlag,
  getSetFlag,
  saveUserAuth,
  getUserAuth,
  saveUserMenu,
  getUserMenu,
  saveUserSetHome,
  getSaveUserSetHome,
  saveUserSetHomeKeyWord,
  getUserSetHomeKeyWord
};
